import { Suspense, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import MainLayout from './MainLayout';
import LoadingFallback from './LoadingFallback';
import ErrorBoundary from './ErrorBoundary';
import { isAuthenticated } from '../../lib/auth';

export default function ProtectedLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  // 渲染受保护内容前校验 token（含 exp 过期检查）
  // App.tsx 的 effect 仍保留，处理 /login 重定向等边角场景
  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/login', { replace: true, state: { from: location.pathname } });
    }
  }, [navigate, location.pathname]);

  return (
    <MainLayout>
      <ErrorBoundary>
        <Suspense fallback={<LoadingFallback />}>
          <Outlet />
        </Suspense>
      </ErrorBoundary>
    </MainLayout>
  );
}
